import React from 'react';
import {
  FileText,
  Lightbulb,
  HelpCircle,
  ListChecks,
  Sparkles,
  Image,
  Info,
  MessageCircle,
  LayoutTemplate,
  Settings,
  Sun,
  Moon
} from 'lucide-react';
import packageJson from '../package.json';

const TabNavigation = ({ activeTab, onTabChange, onShowTemplateSelection, lightMode, onToggleLightMode, onSetLightMode }) => {
  const apps = [
    {
      id: 'planner-basic',
      label: 'Planner',
      description: 'Outline your lesson with the basic planner'
    },
    {
      id: 'prompt-generator',
      label: 'AI Prompt',
      description: 'Generate AI prompts for lesson planning'
    },
    {
      id: 'lesson-template',
      label: 'Slides',
      description: 'Create and edit your lesson'
    },
    {
      // "Configure" rather than "Settings": the toolbar gear on the slides row
      // is the app's settings menu, and two things called Settings that do
      // different jobs is one too many. This tab configures the deck.
      id: 'template-settings',
      label: 'Configure',
      description: 'Configure this slide deck — template controls, backgrounds and styling'
    }
  ];

  const utilityLinks = [
    {
      id: 'features',
      label: 'Features',
      url: '/features.html'
    },
    {
      id: 'examples',
      label: 'Examples',
      url: '/examples.html'
    },
    {
      id: 'help',
      label: 'Help',
      url: '/help/'
    }
  ];

  const handleAppClick = (appId) => {
    onTabChange(appId);
  };

  return (
    <nav id="tab-navigation" className="site-nav sticky top-0 z-[70]">
      <div className="max-w-7xl mx-auto px-4 h-[42px] flex items-center">
        {/* New Template button */}
        {onShowTemplateSelection && (
          <button
            onClick={onShowTemplateSelection}
            className="new-template-btn"
            title="Create new lesson from template"
          >
            <LayoutTemplate className="w-4 h-4" />
            <span>New</span>
          </button>
        )}

        {/* Left: App switcher as pill/toggle group */}
        <div className="app-switcher">
          {apps.map((app) => (
            <button
              key={app.id}
              onClick={() => handleAppClick(app.id)}
              className={activeTab === app.id ? 'active' : ''}
              title={app.description}
            >
              {app.label}
            </button>
          ))}
        </div>

        <div className="spacer"></div>

        {/* Right: Utility links */}
        <div className="nav-links">
          {utilityLinks.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noreferrer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://buymeacoffee.com/lessonplannerone"
            target="_blank"
            rel="noreferrer"
            className="coffee-btn"
          >
            ☕ Support
          </a>
          {onSetLightMode && (
            <div className="theme-toggle-group">
              <button
                type="button"
                onClick={() => onSetLightMode(true)}
                className={`theme-toggle-btn ${lightMode ? 'active' : ''}`}
                title="Switch to Light Mode"
              >
                <Sun size={14} />
              </button>
              <button
                type="button"
                onClick={() => onSetLightMode(false)}
                className={`theme-toggle-btn ${!lightMode ? 'active' : ''}`}
                title="Switch to Dark Mode"
              >
                <Moon size={14} />
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default TabNavigation;
